import set from 'lodash/set';
import axios from 'axios';

import config from 'config';

export default {
    state: {
        jwt: localStorage.getItem('jwt'),
        user: null,
        enums: null,
    },
    actions: {
        async getCurrentUser({state, commit}) {
            let response = await axios.get(`${config.API_URL}user`)

            commit('updateState', {state, property: 'user', value: response.data.user});

            return response;
        },
        async getEnums({state, commit}) {
            let response = await axios.get(`${config.API_URL}enums`);

            commit('updateState', {state, property: 'enums', value: response.data});

            return response;
        },
    },
    mutations: {
        updateState(rootState, {state, property, value}) {
            set(state, property, value);
        },
        setPaginatableCollection(state, {paginatableCollection, data}) {
            paginatableCollection.collection = data._embedded.items;
            paginatableCollection.initialized = true;
            paginatableCollection.total = data.total_results;
            paginatableCollection._links = data._links;

            if (data._embedded.items.length === paginatableCollection.limit) {
                paginatableCollection.page++;
                paginatableCollection.canLoad = true;
            } else {
                paginatableCollection.canLoad = false;
            }
        },

        resetPaginatableCollection(state, paginatableCollection) {
            paginatableCollection.collection = [];
            paginatableCollection.page = 0;
            paginatableCollection.total = 0;
            paginatableCollection.canLoad = true;
            paginatableCollection.initialized = false;
        },
    },
};
